<template>
  <base-modal
    hookSufix="Enable2FAModal"
    content-class="enable-2FA-modal"
    :modalWidth="'520px'"
    :minHeight="'unset'"
    :persistent="false"
    :hideCloseBtn="true"
    :disableDefaultPadding="true"
    :onCloseHook="onClose"
  >
    <template #content>
      <v-row no-gutters>
        <div
          class="icon-wrapper"
          :class="{ 'theme--dark': $vuetify.theme.dark }"
        >
          <v-icon :color="$vuetify.theme.dark ? '#FFC71F' : '#FFC107'" size="48"
            >panda-security-on</v-icon
          >
        </div>
        <v-spacer></v-spacer>
        <v-icon class="close-btn" @click="closeModal">panda-close</v-icon>
      </v-row>
      <div class="enable-2fa-modal-content">
        <p class="enable-2fa-modal-content--title body-bold-medium">
          {{ $t('message.pages.users.twoFactor.enable2faModal.title') }}
        </p>
        <p
          class="description body-regular-small"
          v-html="
            $t('message.pages.users.twoFactor.enable2faModal.description')
          "
        ></p>
      </div>
      <v-divider></v-divider>
    </template>
    <template #card-actions>
      <div class="footer">
        <v-btn text @click="openHelp" class="text-link body-bold-small">
          {{ $t('message.pages.users.twoFactor.enable2faModal.article') }}
          <v-icon small class="ml-1">mdi-open-in-new</v-icon>
        </v-btn>
        <v-spacer />
        <base-btn type="primary" depressed @click="confirm">{{
          $t('message.pages.users.twoFactor.enable2faModal.enableBtn')
        }}</base-btn>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue'
import BaseBtn from '@/components/BaseBtn.vue'
export default {
  name: 'Enable2FAModal',
  components: {
    BaseModal,
    BaseBtn,
  },
  data() {
    return {
      wasManuallyClosed: false,
    }
  },
  methods: {
    confirm() {
      this.$emit('confirmed')
      this.$root.$emit('closeEnable2FAModal')
    },
    openHelp() {
      const link = this.$t('message.pages.users.twoFactor.articleLink')
      window.open(link, '_blank')
    },
    onClose() {
      this.$emit('cancelEnable')
    },
    closeModal() {
      this.$root.$emit('closeEnable2FAModal')
    },
  },
}
</script>

<style lang="scss" scoped>
.enable-2fa-modal-content {
  display: flex;
  flex-direction: column;
  align-items: start;
  text-align: start;
  padding: $spacing-07;
}

.icon-wrapper {
  padding: $spacing-05;
  margin-left: $spacing-07;
  border-radius: 56px;
  width: 80px;
  &.theme--dark {
    background-color: varFigma(feedback-warning-background);
  }
}

.description {
  color: varFigma(neutral-40-light);
  letter-spacing: 0.05em;
  margin-bottom: 0 !important;
}

.description strong {
  font-weight: 700;
}

.enable-2fa-modal-content--title {
  color: varFigma(neutral-20-dark);
  letter-spacing: 0.05em;
}

.footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: $spacing-07 $spacing-07 0 $spacing-07;
}

.text-link {
  text-transform: none;
  color: varFigma(brand-60-base) !important;
  padding: 0 !important;
  height: 21px !important;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  &.v-btn::before {
    background-color: transparent;
  }
}
.close-btn {
  width: 24px;
  height: 24px;
  align-items: flex-start;
  margin-right: $spacing-07;
  &.v-icon.v-icon::after {
    background-color: transparent;
  }
}
</style>
<style lang="scss">
.enable-2FA-modal {
  padding: $spacing-07 0;
}
</style>
